var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.75H18.25V0.75C18.25 0.551088 18.171 0.360322 18.0303 0.21967C17.8897 0.0790178 17.6989 0 17.5 0H12.25C12.0511 0 11.8603 0.0790178 11.7197 0.21967C11.579 0.360322 11.5 0.551088 11.5 0.75V4.5H7C6.80109 4.5 6.61032 4.57902 6.46967 4.71967C6.32902 4.86032 6.25 5.05109 6.25 5.25V9H2.5C2.30109 9 2.11032 9.07902 1.96967 9.21967C1.82902 9.36032 1.75 9.55109 1.75 9.75V15.75H1C0.801088 15.75 0.610322 15.829 0.46967 15.9697C0.329018 16.1103 0.25 16.3011 0.25 16.5C0.25 16.6989 0.329018 16.8897 0.46967 17.0303C0.610322 17.171 0.801088 17.25 1 17.25H19C19.1989 17.25 19.3897 17.171 19.5303 17.0303C19.671 16.8897 19.75 16.6989 19.75 16.5C19.75 16.3011 19.671 16.1103 19.5303 15.9697C19.3897 15.829 19.1989 15.75 19 15.75ZM13 1.5H16.75V15.75H13V1.5ZM7.75 6H11.5V15.75H7.75V6ZM3.25 10.5H6.25V15.75H3.25V10.5Z",
    fill: "#7BD2EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.9aebc6800d740a4c7c672f2aa626b9b1.svg";
export { ForwardRef as ReactComponent };